const ITEMS = [
  "Nature",
  "Energy",
  "Harmony",
  "Handcrafted",
  "Seven Chakras",
  "~300 Gemstones",
  "Meaningful Décor",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="border-y border-[#1B1915]/10 bg-[#F4F0E6]/60 py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif-display text-lg sm:text-xl italic text-[#1B1915]/70 px-6">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#C6A15B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
